import moment from 'moment-timezone';
import { createAction, handleActions } from 'redux-actions';
import { push } from 'connected-react-router';
import swal from 'sweetalert';
import tzlookup from 'tz-lookup';
import { receiveLogout } from './login';
import { business } from './../services/api';
import { AnalyticsService } from '../services/AnalyticsService';

export const finishBusinessLoad = createAction('BUSINESS_SUCCESS', (data) => data);
export const finishBusinessHours = createAction('BUSINESS_HOURS_SUCCESS', (data) => data);
export const updateMedia = createAction('UPDATE_BUSINESS_MEDIA', (media) => media);

export type Store = Business;

let initial;

try {
  initial = JSON.parse(localStorage.getItem('businessInfo') || '');
  AnalyticsService.identify(initial.email);
  AnalyticsService.people.set(initial);
} catch (error) {
  initial = {};
}

export function fetchBusinessInfo() {
  return (dispatch: Function) => {
    return business.info().then((json: any) => {
      const timezone = tzlookup(json.data.location.lat, json.data.location.lon);
      moment.tz.setDefault(timezone);
      AnalyticsService.identify(json.data.email);
      AnalyticsService.people.set(json.data);
      if (!localStorage.getItem('businessInfo')) AnalyticsService.track('Login', {});
      localStorage.setItem('businessInfo', JSON.stringify(json.data));
      dispatch(finishBusinessLoad(json.data));
    });
  };
}

export function fetchWorkingHours(businessId: string) {
  return async (dispatch: Function) => {
    return business.getHours(businessId).then((json: any) => {
      dispatch(finishBusinessHours(json.working_hours));
    });
  };
}

export function updateInfo(data: any) {
  return (dispatch: Function) => {
    return business.updateInfo({ type: 'business', ...data }).then((json: any) => {
      dispatch(finishBusinessLoad(json.data));
    });
  };
}

export function getInstagramPost(data: any) {
  return (dispatch: Function) => {
    localStorage.setItem('currentInstagramPost', JSON.stringify(data));
    dispatch(push(`/instagram/view/${data.id}`));
    dispatch({ type: 'LOAD_INSTAGRAM_POST', data });
  };
}

export function updateWorkingHours(hours: any, businessId: string) {
  return (dispatch: Function) => {
    return business
      .updateHours(hours, businessId)
      .then((json) => {
        dispatch(push('/profile'));
        dispatch(fetchWorkingHours(businessId));
      })
      .catch((error) => {
        swal('Failed to update working hours!', 'Are you hours formatted correctly?', 'error');
      });
  };
}

export default handleActions(
  {
    [finishBusinessLoad](state: Store, { payload }): Store {
      return { ...state, ...payload };
    },
    [updateMedia](state: Store, { payload }) {
      return { ...state, media: payload };
    },
    [finishBusinessHours](state: Store, { payload }): Store {
      return { ...state, working_hours: payload };
    },
    [receiveLogout]() {
      return {};
    },
  },
  initial
);
